angular
    .module('app')
    .component('userExport', {
        templateUrl: '/templates/pages/user-export/user-export.html',
        controller: 'UserExportController',
        controllerAs: 'vm',
    });